import { render } from "./TwoPartLayout.vue?vue&type=template&id=3e799221&scoped=true"
import script from "./TwoPartLayout.vue?vue&type=script&lang=js"
export * from "./TwoPartLayout.vue?vue&type=script&lang=js"

import "./TwoPartLayout.vue?vue&type=style&index=0&id=3e799221&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e799221"]])

export default __exports__